(() => {
	if(customElements.get('appointment-popup')) {
		return;
	}

	class PopUp extends HTMLElement {
		constructor() {
			super();
		}

		connectedCallback() {
			this.timer = setTimeout(() => {
				this.classList.add('show');
			}, 3000);
		}

		disconnectedCallback() {
    	clearTimeout(this.timer);
    }
	}
		
	customElements.define('appointment-popup', PopUp)
})();